import { Doctor } from 'domain/entities/doctor-model'
import { Patient } from 'domain/entities/patient-model'
import { useServices } from 'presentation/hooks/use-services'
import {
  AmbulatoryScheduleAddComment,
  AmbulatoryScheduleCommentsHistory,
  AmbulatoryScheduleContactRegistarionHistory,
  AmbulatoryScheduleDoctorInfo,
  AmbulatoryScheduleHeader,
  AmbulatoryScheduleInfo,
  AmbulatorySchedulePatientInfo,
  AmbulatoryScheduleReScheduleHistory
} from 'presentation/hospital/components/AmbulatoryScheduleResume'
import Container from 'presentation/hospital/components/Container'
import ActualPage from 'presentation/shared/components/ActualPage'
import Heading from 'presentation/shared/components/Heading'
import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { toast } from 'react-toastify'
import { SchedulesRow } from '../Home/Ambulatory'
import * as S from './styles'

export default function AmbulatoryScheduleLayout() {
  const [comments, setComments] = useState<
    {
      comment: string
      createdAt: Date
    }[]
  >([])
  const [patient, setPatient] = useState<Patient>()
  const [doctor, setDoctor] = useState<Doctor>()
  const patientService = useServices().patient
  const doctorService = useServices().doctor
  const history = useHistory()
  const { state } = useLocation<{
    schedule: SchedulesRow
  }>()
  // historySchedule
  const getPatient = async (patient_id: number) => {
    try {
      const findPatient = await patientService.loadPatientInfo(
        ['birthday', 'gender', 'phone', 'landlinePhone', 'email', 'name'],
        patient_id
      )
      setPatient(findPatient)
    } catch (error) {
      toast.error('Erro aos buscar informações do paciente')
    }
  }

  const getDoctor = async (doctor_id: number) => {
    try {
      const findDoctor = await doctorService.loadDoctorInfo(doctor_id, [
        'name',
        'crm',
        'crmUf',
        'specialty'
      ])
      setDoctor(findDoctor)
    } catch (error) {
      toast.error('Erro aos buscar informações do médico')
    }
  }

  useEffect(() => {
    if (state?.schedule?.patient_id) {
      getPatient(state?.schedule?.patient_id)
    }
    if (state?.schedule?.doctor_id) {
      getDoctor(state?.schedule?.doctor_id)
    }
  }, [state?.schedule?.patient_id, state?.schedule?.doctor_id])

  const setNewComment = async (comment: string) => {
    setComments([
      ...comments,
      {
        comment,
        createdAt: new Date()
      }
    ])
  }

  return (
    <>
      <Container>
        <Heading size="xlarge" color="primary">
          Ambulatório
        </Heading>
        <ActualPage text="Voltar" onClick={() => history.goBack()} />
        <S.ContainerForm>
          <AmbulatoryScheduleHeader schedule={state?.schedule} />
          <AmbulatoryScheduleReScheduleHistory />
          <AmbulatorySchedulePatientInfo patient={patient} />
          <AmbulatoryScheduleDoctorInfo doctor={doctor} />
          <AmbulatoryScheduleInfo schedule={state?.schedule} />
          <AmbulatoryScheduleAddComment setNewComment={setNewComment} />
          <AmbulatoryScheduleCommentsHistory comments={comments} />
          <AmbulatoryScheduleContactRegistarionHistory
            contactRegistrations={[
              {
                contact: true,
                contactType: 'telefone',
                createdAt: new Date()
              },
              {
                contact: false,
                contactType: 'telefone',
                createdAt: new Date()
              }
            ]}
          />
        </S.ContainerForm>
      </Container>
    </>
  )
}
